{
  "name": "@homer.core/entry",
  "version": "1.1.1",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.core/application": "*",
    "@homer.core/page": "*",
    "@homer.core/storage.local": "*",
    "@homer.utility/validator.isundefined": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
